// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
// import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-ct-dark.png";


// import ContactUs from "layouts/pages/landing-pages/contact-us";
import Author from "layouts/pages/landing-pages/author";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "CamerClean",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/",
    },
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/channel/",
    },
  ],
  menus: [
    {
      name: "company",
      items: [
        { name: "Accueil", href: "/" },
        { name: "Prise de RDV & contact", route: "/rdv",
            component: <Author /> },
        // { name: "Contactez-nous",  route: "/contact-us",
        //     component: <ContactUs /> },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      Tous droits réservés. Copyright &copy; {date} CamerClean by{" "}
      <MKTypography
        component="a"
        href="#"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Re7
      </MKTypography>
      .
    </MKTypography>
  ),
};
